import React, {createRef, useState} from 'react';
import {useQueryClient} from "react-query";
import {useAuth0} from "@auth0/auth0-react";
import MaterialTable from "@material-table/core";
import { TablePagination, useTheme } from "@material-ui/core";
import { ValidatorColumn, ColumnWidth } from "../../../blocks/ColumnHelper";
import AircraftMaxPayloadsValidator from "../validators/AircraftMaxPayloadsValidator";
import {useAircraftMaxPayloads, useAddAircraftMaxPayload, useUpdateAircraftMaxPayloads, useDeleteAircraftMaxPayloads } from "../../../services/aircraft";
import { MaskedNumber } from "../../../controls";
import { defaultComponents } from '../../../controls/Material-Table-Components';
import AirportLookup from "../../Airports/components/AirportsLookup";


const AircraftMaxPayloadList = (_props) => {
  const theme = useTheme();
  const {isAuthenticated} = useAuth0();
  const validatorColumn = ValidatorColumn(AircraftMaxPayloadsValidator, true);

  const props = {
    ..._props
  }
  const [state] = useState({
    canEdit: props.canEdit,
    activeRow: null,
  });

  const tableRef = createRef({state: {lastEditingRow: false}});

  const handleAddAircraftMaxPayload = useAddAircraftMaxPayload();
  const handleUpdateAircraftMaxPayload = useUpdateAircraftMaxPayloads();
  const handleDeleteAircraftMaxPayload = useDeleteAircraftMaxPayloads();

  const queryClient = useQueryClient();
  const extraKeys = [props.aircraftUuid];
  const aircraftMaxPayloads = useAircraftMaxPayloads({tableRef, queryClient, extraKeys});

  const getColumns = (props) => {
    const baseColumn = {
      cellStyle: { fontSize:14, padding: "8px 2px" },
      headerStyle: { padding: "8px 2px" },
      editable: props.canEdit ? "always" : "never",
      emptyValue: "",
      initialEditValue: "",
    };

    return [
      {...validatorColumn},
      /*
        Can use ...ColumnWidth(70) to generate a fixed width column
      */

      {
        ...baseColumn,
        ...(ColumnWidth(80)),
        title: "Origin",
        field: "origin",
        editable: props.canEdit ? "always" : "never",
        editComponent: (props) => (
          <AirportLookup
            value={props.value}
            onChange={props.onChange}
          />
        ),
      },
      {
        ...baseColumn,
        ...(ColumnWidth(80)),
        title: "Destination",
        field: "destination",
        editable: props.canEdit ? "always" : "never",
        editComponent: (props) => (
          <AirportLookup
            value={props.value}
            onChange={props.onChange}
          />
        ),
      },
      {
        ...baseColumn,
        ...(ColumnWidth(150)),
        title: "Max Payload",
        field: "maxPayload",
        type: "numeric",
        emptyValue: null,
        initialEditValue: null,
        editable: props.canEdit ? "always" : "never",
        editComponent: (props) => (
          <MaskedNumber
            value={props.value}
            decimalScale={0}
            fixedDecimalScale={true}
            onChange={props.onChange}
            style={{ fontSize: "0.875rem", textAlign: "right" }}
          />
        ),
        render: (props) => (
          <MaskedNumber
            displayType="text"
            value={props.maxPayload}
            decimalScale={0}
            fixedDecimalScale={true}
          />
        )
      },
      {
        ...baseColumn,
      },
    ];
  };

  return (isAuthenticated &&
      <div style={{marginLeft: 50}}>
        <MaterialTable
            tableRef={tableRef}
            style={{
              backgroundColor: "#fdfdfd",
              border: "2px solid #aaaaaa",
              boxShadow: "none",
              borderRadius: 0,
            }}
            options={{
              actionsColumnIndex: -1,
              cellStyle: {
                padding: "8px 2px",
              },
              headerStyle: {
                backgroundColor: theme.palette.childTableHeader.backgroundColor,
                color: theme.palette.childTableHeader.textColor,
                padding: "2px",
              },
              toolbarButtonAlignment: "right",
              pageSize: 5,
              detailPanelType: "single",
              addRowPosition: "first",
            }}
            components={{
              ...defaultComponents,
              Pagination: (props) => (
                  <TablePagination
                      {...props}
                      rowsPerPageOptions={[5, 10, 15]}
                  />
              ),
            }}
            title="Aircraft Max Payloads by Route"
            columns={getColumns({canEdit: state.canEdit})}
            data={aircraftMaxPayloads.data}
            editable={{
              isEditable: () => {
                return state.canEdit;
              },
              isDeletable: () => {
                return state.canEdit;
              },
              onRowAdd: state.canEdit
                  ? (newData) => new Promise((resolve, reject) => {
                    handleAddAircraftMaxPayload.mutate({record: {...newData, aircraftUuid: props.aircraftUuid, aircraftTailNumber: props.aircraftTailNumber}, resolve, reject, extraKeys});
                  })
                  : undefined,
              onRowUpdate: (newData, oldData) =>
                  new Promise((resolve, reject) => {
                    handleUpdateAircraftMaxPayload.mutate({record: {...newData, aircraftUuid: props.aircraftUuid}, oldRecord: oldData, resolve, reject, extraKeys});
                  }),
              onRowDelete: (oldData) =>
                  new Promise((resolve, reject) => {
                    handleDeleteAircraftMaxPayload.mutate({oldRecord: {...oldData, aircraftUuid: props.aircraftUuid}, resolve, reject, extraKeys});
                  }),
            }}
        />
      </div>
  );

}

export default AircraftMaxPayloadList;
